import { ServiceInfo } from './shared-constants';
import * as moment from 'moment';

export const getServiceStartAt = (s: ServiceInfo) => {
	const today = moment().startOf('day');
	const onSaleFrom = moment(s.onSaleFrom);
	const dateRef = onSaleFrom.diff(today) > 0 ? onSaleFrom.clone() : today.clone();

	if (s.serviceStartRule === 'SubscriptionDay') {
		return dateRef.toISOString();
	}
	if (s.serviceStartRule === 'FirstDayOfCurrentMonth') {
		return dateRef.startOf('month').toISOString();
	}
	if (s.serviceStartRule === 'FirstDayOfNextMonth') {
		return dateRef.add(1, 'month').startOf('month').toISOString();
	}

	return dateRef.toISOString();
};

export const getServiceEndAt = (s: ServiceInfo) => {
	return moment(s.onSaleUntil).toISOString();
};

export const getServiceCost = (s: ServiceInfo, startAt: string, endAt: string) => {
	const diffInMonths = Math.ceil(moment(endAt).diff(startAt, 'month', true));

	if (s.serviceBillingType === 'PerUse') {
		return s.price.toFixed(2);
	}
	if (s.serviceBillingType === 'Episodic') {
		return (diffInMonths * s.price).toFixed(2);
	}
	if (s.serviceBillingType === 'LumpSum') {
		return ((s.price / s.duration) * diffInMonths).toFixed(2);
	}
	if (s.serviceBillingType === 'Monthly') {
		const pricePerDay = s.price / moment(startAt).daysInMonth();
		const diffInDays = Math.ceil(moment(startAt).endOf('month').diff(startAt, 'days', true));

		if (s.partialMonthCalculation === 'Ratio') {
			return (pricePerDay * diffInDays).toFixed(2);
		}

		return moment(startAt).daysInMonth() >= 15 ? (s.price / 2).toFixed(2) : s.price;
	}
	if (s.serviceBillingType === 'DAS') {
		return s.price.toFixed(2);
	}
	return diffInMonths;
};
